import bagging_guide from "../assests/images/guides/bagging-guide.svg";
// import pincode_guide from "../assests/images/guides/pincode-mapping.svg";
import route_guide from "../assests/images/guides/route-guide.svg";
import sorting_guide from "../assests/images/guides/sorting-guide.svg";
import constants from "../constants/constants";

const { ROLES } = constants;
const { HUB_ADMIN } = ROLES;

export const guidePath = [
  {
    id: 1,
    imgSrc: sorting_guide,
    title: "Sorting Guide",
    route: "/sort-shipment",
    disable: false,
    childPresent: false,
    role: [HUB_ADMIN],
  },
  {
    id: 2,
    imgSrc: bagging_guide,
    title: "Bagging Guide",
    route: "/shipment-bagging",
    disable: false,
    childPresent: false,
    role: [HUB_ADMIN],
  },
  {
    id: 3,
    imgSrc: route_guide,
    title: "Outscan",
    route: "/out-scan-bag",
    disable: false,
    childPresent: false,
    role: [HUB_ADMIN],
  },
//   {
//     id: 4,
//     imgSrc: pincode_guide,
//     title: "Pincode Guide",
//     route: "",
//     disable: false,
//     childPresent: false,
//     role: [HUB_ADMIN],
//   },
];
